import React, { useState, useEffect } from "react";
import Header from "./Header";
import Loader from "./Utils/Loader";
import { Userlogin } from "./Utils/general-function";
import { useNavigate } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import Document from "./Document";
import NoCars from "./Utils/NoCars";
import Defaultpreview from "./Utils/Defaultpreview";

function SearchDoc(props) {
  const [loading, setLoading] = useState(true);
  const [Carlist, setCarlist] = useState([]);
  const [CarDOclist, setCarDOclist] = useState([]);
  const [searchtext, setSearchText] = useState("");
  const [originalList, setOriginalList] = useState([]);
  const [selectedcar, setSelectedcar] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (Userlogin()) {
      const header = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
        },
      };

      fetch(
        process.env.REACT_APP_API_ENDPOINT + "/api/Carmaster/Dealercar",
        header,
      )
        .then((response) => response.json())
        .then((res) => {
          setCarlist(res.Data || []);
          setOriginalList(res.Data || []);
          setLoading(false);
        });
    } else {
      navigate("/Login");
    }
  }, [navigate]);

  const Onchange = async (e) => {
    setSearchText(e.target.value);
    let filterdlist = originalList.filter((d) =>
      d.carnumber.toLowerCase().includes(e.target.value.toLowerCase()),
    );
    setCarlist(filterdlist);
    // if (e.target.value !== "" && filterdlist.length > 0) {
    //    console.log(filterdlist,"in");
    //   document.getElementById("searchlist").style.display = "block";
    // }

    setSelectedcar("");
  };

  const GetDocs = (id, no) => {
    setLoading(true);
    document.getElementById("searchlist").style.display = "none";
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
      },
    };
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/cardocumentmaster/Allcardocument?carid=" +
        id,
      header,
    )
      .then((response) => response.json())
      .then((res) => {
        setCarDOclist(res.Data);
        setSelectedcar(no);
        // document.getElementById("searchlist").style.display="block"
        setLoading(false);
      });
  };
  const formatResult = (Carlist) => {
    return (
      <>
        <ul className="doc-searchresult" id="searchlist">
          {Carlist.map((list) => (
            <li
              key={list.carnumber}
              style={{ display: "block", textAlign: "left" }}
              onClick={(e) => GetDocs(list.carid, list.carnumber)}
            >
              {list.carnumber} -{list.companyid}&nbsp;
              {list.carmodelid}
            </li>
          ))}
        </ul>
      </>
    );
  };

  return (
    <div>
      {loading ? <Loader /> : null}
      <Header />
      <div className="page-space">
        <div className="car-searchbar">
          <button>
            <img src="assets/images/search-icon.png" alt="" />
          </button>
          <input
            type="text"
            className="doc-serachtext"
            placeholder="Enter vehicle no..."
            onChange={Onchange}
          />
        </div>

        {searchtext ? (
          Carlist.length > 0 ? (
            formatResult(Carlist)
          ) : (
            <NoCars />
          )
        ) : (
          <Defaultpreview
            img="assets/images/search-doc.png"
            msg="Quickly find your car document by entering the car number !!"
          />
        )}
        {searchtext === "" || selectedcar === "" ? null : (
          <Document dataFromParent={{ no: selectedcar, list: CarDOclist }} />
        )}
      </div>
    </div>
  );
}

export default SearchDoc;
